import script from "./InquiryFlowDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InquiryFlowDialog.vue?vue&type=script&setup=true&lang=ts"

import "./InquiryFlowDialog.vue?vue&type=style&index=0&id=b43531d2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b43531d2"]])

export default __exports__